var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { COLOR } from "../../theme/constants"; // TODO: Add siezes to constants
// TODO: Replace switch with Map

var getDescriptionLeading = function getDescriptionLeading(size) {
  switch (size) {
    case "large":
      return "28px";

    case "regular":
    default:
      return "24px";
  }
};

var getDescriptionColor = function getDescriptionColor(colorProp) {
  switch (colorProp) {
    case "black":
      return COLOR.black;

    case "white":
      return COLOR.white;

    case "grey":
    default:
      return COLOR.grey;
  }
};

export var DescriptionWprapper = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* stylelint-disable-next-line function-name-case */\n  color: ", ";\n  font-family: \"Sans\", \"Arial\", sans-serif;\n  font-weight: 400;\n  /* stylelint-disable-next-line function-name-case */\n  line-height: ", ";\n"], ["\n  /* stylelint-disable-next-line function-name-case */\n  color: ", ";\n  font-family: \"Sans\", \"Arial\", sans-serif;\n  font-weight: 400;\n  /* stylelint-disable-next-line function-name-case */\n  line-height: ", ";\n"])), function (_a) {
  var _b = _a.color,
      color = _b === void 0 ? "grey" : _b;
  return getDescriptionColor(color);
}, function (_a) {
  var _b = _a.leading,
      leading = _b === void 0 ? "regular" : _b;
  return getDescriptionLeading(leading);
});
var templateObject_1;